import { render, staticRenderFns } from "./WysiwygField.vue?vue&type=template&id=3f5fd3ca"
import script from "./WysiwygField.vue?vue&type=script&lang=js"
export * from "./WysiwygField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports